import { useEffect, useRef } from 'react';
import Yesbank from '../assets/YESBANK.NS_BIG.webp'
import DBS from '../assets/dbs.webp'

const partners = [
  { 
    id: 1,
    name: 'Yes Bank',
    image: Yesbank
  },
  { 
    id: 2,
    name: 'DBS Bank',
    image: DBS
  }
];

export default function Partners() {
  const partnersRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-8');
          }
        });
      },
      { threshold: 0.1 }
    );

    const logos = document.querySelectorAll('.partner-logo');
    logos.forEach((logo) => {
      observer.observe(logo);
    });

    return () => {
      logos.forEach((logo) => {
        observer.unobserve(logo);
      });
    };
  }, []);

  return (
    <section className="py-10 px-4 bg-gradient-to-b lg:px-[15%]  from-slate-50 to-white">
      <div className="max-w-screen-xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-4xl font-bold text-slate-800 mb-4">
            Our Partners
          </h2>
          
        </div>
        
        <div 
          ref={partnersRef} 
          className="grid grid-cols-2 md:grid-cols-2 gap-8 max-w-[500px] mx-auto"
        >
          {partners.map((partner, index) => (
            <div 
              key={partner.id}
              className=""
              style={{ transitionDelay: `${index * 150}ms` }}
            >
              <div className="rounded-xl transition-all duration-300 aspect-square flex items-center justify-center group overflow-hidden mt-[-100px]">
                <img 
                  src={partner.image}
                  alt={`${partner.name} logo`}
                  className="md:w-full h-50 w-[100px md:h-full object-contain"
                />
              </div>
            </div>
          ))}
        </div>

        
      </div>
    </section>
  );
}